/* HIGHCOOL quote form: inline validation (progressive enhancement) + contact click tracking.
   Native constraint validation stays on as the backstop; this script replaces the browser
   bubbles with inline messages and adds the "at least one product line" rule. */
(function () {
  'use strict';

  /* ---------- contact click tracking (shared with hc-contact-tracking.js) ---------- */
  function bindContactTracking() {
    if (window.__hcContactTracking) return;
    window.__hcContactTracking = true;
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var method = null;
      if (/^mailto:/i.test(href)) method = 'email';
      else if (/(^https?:\/\/)?(api\.)?wa\.me\//i.test(href) || /whatsapp\.com\/send/i.test(href)) method = 'whatsapp';
      if (!method) return;
      var data = {
        method: method,
        link_url: href.split('?')[0],
        link_text: (a.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80),
        page_path: window.location.pathname
      };
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'hc_contact_click', method: data.method, link_url: data.link_url, link_text: data.link_text, page_path: data.page_path });
        if (typeof window.gtag === 'function') window.gtag('event', 'hc_contact_click', data);
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('hc_contact_click', data);
      } catch (err) {}
    }, true);
  }

  /* ---------- form validation ---------- */
  function msgEl(field) {
    var wrap = field.closest('.hc-qf__field');
    return wrap ? wrap.querySelector('.hc-qf__msg') : null;
  }

  function setDescribedBy(el, id, on) {
    var ids = (el.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    var i = ids.indexOf(id);
    if (on && i === -1) ids.push(id);
    if (!on && i !== -1) ids.splice(i, 1);
    if (ids.length) el.setAttribute('aria-describedby', ids.join(' '));
    else el.removeAttribute('aria-describedby');
  }

  function messageFor(el) {
    var v = el.validity;
    var holder = el;
    if (el.type === 'radio') holder = el.form.querySelector('input[name="' + el.name + '"][data-msg-required]') || el;
    if (v.valueMissing) return holder.getAttribute('data-msg-required') || 'This field is required.';
    if (v.typeMismatch) return el.getAttribute('data-msg-type') || 'Please check this field.';
    if (v.customError) return el.validationMessage;
    return el.validationMessage || 'Please check this field.';
  }

  function showError(el, text) {
    var m = msgEl(el);
    var group = el.closest('.hc-qf__group');
    if (m) { m.textContent = text; m.hidden = false; }
    if (group) {
      group.setAttribute('aria-invalid', 'true');
      if (m) group.querySelectorAll('input').forEach(function (i) { setDescribedBy(i, m.id, true); });
    } else {
      el.setAttribute('aria-invalid', 'true');
      if (m) setDescribedBy(el, m.id, true);
    }
  }

  function clearError(el) {
    var m = msgEl(el);
    var group = el.closest('.hc-qf__group');
    if (m) { m.textContent = ''; m.hidden = true; }
    if (group) {
      group.removeAttribute('aria-invalid');
      if (m) group.querySelectorAll('input').forEach(function (i) { setDescribedBy(i, m.id, false); });
    } else {
      el.removeAttribute('aria-invalid');
      if (m) setDescribedBy(el, m.id, false);
    }
  }

  function initForm(root) {
    var form = root.querySelector('form');
    if (!form || form.__hcQf) return;
    form.__hcQf = true;

    var products = Array.prototype.slice.call(form.querySelectorAll('[data-hc-qf-product]'));
    var productGroup = form.querySelector('[data-hc-qf-group="checkbox"]');
    var productMsg = productGroup ? productGroup.getAttribute('data-msg-required') : '';

    function syncProducts() {
      if (!products.length) return true;
      var any = products.some(function (p) { return p.checked; });
      products[0].setCustomValidity(any ? '' : productMsg || 'Please choose at least one option.');
      return any;
    }
    syncProducts();

    var firstInvalid = null;
    var touched = false;

    form.addEventListener('invalid', function (e) {
      var el = e.target;
      e.preventDefault(); // suppress native bubble, we show inline text
      showError(el, messageFor(el));
      if (!firstInvalid) {
        firstInvalid = el;
        setTimeout(function () {
          if (firstInvalid) {
            firstInvalid.focus({ preventScroll: true });
            var wrap = firstInvalid.closest('.hc-qf__field') || firstInvalid;
            wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          firstInvalid = null;
        }, 0);
      }
    }, true);

    function check(el) {
      if (!el || !el.willValidate) return;
      if (el.checkValidity()) clearError(el);
      else showError(el, messageFor(el));
    }

    form.addEventListener('blur', function (e) {
      var el = e.target;
      if (!el.matches || !el.matches('.hc-qf__input')) return;
      if (el.value !== '' || touched) {
        if (el.checkValidity()) clearError(el);
        else showError(el, messageFor(el));
      }
    }, true);

    form.addEventListener('input', function (e) {
      var el = e.target;
      if (el.getAttribute('aria-invalid') === 'true' && el.checkValidity()) clearError(el);
    });

    form.addEventListener('change', function (e) {
      var el = e.target;
      if (el.matches('[data-hc-qf-product]')) {
        syncProducts();
        if (products.some(function (p) { return p.checked; })) clearError(products[0]);
      } else if (el.type === 'radio') {
        clearError(el);
      } else {
        check(el);
      }
    });

    form.querySelector('[type="submit"]') && form.querySelector('[type="submit"]').addEventListener('click', function () {
      touched = true;
      syncProducts();
    });

    // Fires only when the form is valid (native validation runs first).
    form.addEventListener('submit', function () {
      try {
        var t = form.querySelector('[data-hc-qf-type]');
        sessionStorage.setItem('hc_qf_pending', JSON.stringify({
          request_type: t ? t.value : 'quote',
          source: root.getAttribute('data-source') || ''
        }));
      } catch (err) {}
    });
  }

  function focusStatus() {
    var box = document.querySelector('[data-hc-qf-success], [data-hc-qf-errors]');
    if (box) {
      box.focus({ preventScroll: true });
      box.scrollIntoView({ block: 'center' });
    }
  }

  function init() {
    bindContactTracking();
    document.querySelectorAll('[data-hc-qf]').forEach(initForm);
    focusStatus();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-hc-qf]');
    if (root) initForm(root);
  });
})();
